export const forgotpassword = {
	/**
	* Gets the programmatic name of the entire locale, with the language, 
	*	country and variant separated by underbars. The Language is always lower case, 
	*	and country is always upper case. If the language is missing, 
	*	the string will begin with an underscore character. 
	*	If both the language and country fields are missing, 
	*	this function will return the empty string, 
	*	even if the variant field is filled in (you cannot have a locale with just a variant-- 
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        forgotpassword:'Forgot Your Password?',
        submit:'Submit',
        loading:'Loading...',
        forgotpassword_hint:'Dont worry. Resetting your password is easy. just tell us the username you register with TCL.',
        confidently: 'Confidently',
        connect_monitor: 'Connect Monitor',
        and:'and',
        control:'control',
        new_things_everyday:'new things Everyday',
        sign_in:'Sign In',
        forgetpassword_hints:"Dont worry, Resetting your password is easy, Just tell us the email address you are registered with Us.",
        powered_by:'Powered By'
    },

    ar: {
        forgotpassword:'هل نسيت رقمك السري؟',
        submit:'إرسال',
        loading:'جار التحميل…',
        forgotpassword_hint:'لا تقلق. إعادة تعيين كلمة المرور الخاصة بك أمر سهل. فقط أخبرنا باسم المستخدم الذي تسجله في TCL.',
        confidently: 'بثقة',
        connect_monitor: 'قم بتوصيل الشاشة',
        and:'و',
        control:'تحكم',
        new_things_everyday:'أشياء جديدة كل يوم',
        sign_in:'تسجيل الدخول',
        forgetpassword_hints:"لا تقلق ، إعادة تعيين كلمة المرور الخاصة بك أمر سهل ، فقط أخبرنا بعنوان البريد الإلكتروني الذي قمت بتسجيله معنا.",
        login_pass_error1:"يرجى تغيير كلمة مرورك الحالية للمتابعة",
        login_pass_error2:"لقد انتهت صلاحية كلمة المرور الخاصة بك ، يرجى التغيير للمتابعة",
        powered_by:'مشغل بواسطة'


    }
}